import React, { useState } from "react";

import AnalyticsOutlinedIcon from "@mui/icons-material/AnalyticsOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import Popover from "@mui/material/Popover";

import { useNavigate } from "react-router-dom";

import { MenuRow, popoverMenuPaperSx } from "components/atoms/PopoverMenu";

import StandartButton from "../../components/atoms/StandartButton";
import { ButtonVariant } from "../../Constant/button";

/**
 * "•••" actions menu for a tracker row: Settings / Reports / Delete.
 * Popover chrome mirrors FieldOptionsSummaryPopover to stay consistent
 * with the existing design system.
 */
const TrackerActionsMenu = ({ settingsTo, reportsTo, onDelete, language }) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();
    const open = Boolean(anchorEl);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleNavigate = (to) => {
        handleClose();
        navigate(to);
    };

    const handleDelete = () => {
        handleClose();
        onDelete?.();
    };

    return (
        <>
            <StandartButton
                variant={ButtonVariant.BLACK_OUTLINED}
                iconButton
                onClick={handleOpen}
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                aria-label={language?.trackers?.more_actions ?? "More actions"}
                data-cy="tracker-actions-menu"
            >
                <MoreHorizIcon fontSize="small" />
            </StandartButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                slotProps={{
                    paper: {
                        sx: popoverMenuPaperSx,
                    },
                }}
                disableRestoreFocus
                disableScrollLock
            >
                <MenuRow
                    icon={<SettingsOutlinedIcon />}
                    label={language?.trackers?.settings ?? "Settings"}
                    onClick={() => handleNavigate(settingsTo)}
                    testId="tracker-action-settings"
                />
                <MenuRow
                    icon={<AnalyticsOutlinedIcon />}
                    label={language?.trackers?.reports ?? "Reports"}
                    onClick={() => handleNavigate(reportsTo)}
                    isLast={!onDelete}
                    testId="tracker-action-reports"
                />
                {onDelete && (
                    <MenuRow
                        icon={<DeleteOutlineIcon />}
                        label={language?.buttons?.delete ?? "Delete"}
                        onClick={handleDelete}
                        testId="tracker-action-delete"
                        danger
                        isLast
                    />
                )}
            </Popover>
        </>
    );
};

export default TrackerActionsMenu;
